import React from 'react';
import classNames from 'classnames/bind';
import { IconArrowsRight } from '@carnica/graphics';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../../../../metric";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Banner = function Banner(_ref) {
  var url = _ref.url,
    title = _ref.title,
    imageUrl = _ref.imageUrl;
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      url: url,
      title: title
    }),
    events: {
      headerMetric: ['handleViewSearchBanners']
    },
    mode: "viewport",
    once: true
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      url: url,
      title: title
    }),
    events: {
      headerMetric: ['handleClickSearchBanners']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement("a", {
    className: cx('banner'),
    href: url,
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('banner-content')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('banner-content__text'),
    color: "primary-invert",
    size: "s",
    tagName: "span"
  }, title), /*#__PURE__*/React.createElement(IconArrowsRight, {
    className: cx('banner-content__icon'),
    color: "primary-invert",
    size: "xs"
  })), imageUrl && /*#__PURE__*/React.createElement("img", {
    alt: "",
    "aria-hidden": "true",
    className: cx('banner-img'),
    src: imageUrl
  }))));
};